import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    level;
    disabled;
    formData = {
        level: this.$props.level,
    };
    levelChange(val) {
        this.formData.level = val;
    }
    changeLevel(val) {
        this.$emit('update:level', val);
    }
    isValidate() {
        return true;
    }
};
__decorate([
    Prop()
], default_1.prototype, "level", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Watch('level')
], default_1.prototype, "levelChange", null);
default_1 = __decorate([
    Component({
        name: 'AlarmLevel',
        components: {},
        i18n: {
            messages: {
                zh: {
                    title: '等级',
                    critical: '重度',
                    major: '中度',
                    minor: '轻度',
                },
                en: {
                    title: 'Level',
                    critical: 'Critical',
                    major: 'Major',
                    minor: 'Minor',
                },
            },
        },
    })
], default_1);
export default default_1;
